import React, { useState, useContext, useEffect } from 'react'
import {
  FieldGroup, FieldRow, HR
} from '../../layout/mixins'
import Dropdown from '../Dropdown'
import Field from '../Field'
import PermissionRow from './PermissionRow'
import { Rows, StyledButton } from './styles'
import {
  PERMISSION_CODES_FORM, PERMISSIONS_CONTACT_LEVELS
} from '../../config/alarmPrivateForm'
import Context from '../../context'

const PrivatePermissionCodes = () => {
  const [numberOfRows, setNumberOfRows] = useState(1)
  const {
    getValue, setValue, getValues, setField
  } = useContext(Context)


  const addRow = () => {
    setNumberOfRows(numberOfRows + 1)
  }

  const renderRows = () => {
    const rows = []
    for (let i = 1; i <= numberOfRows; i++) {
      rows.push(<PermissionRow nth={i} key={i} />)
    }
    return rows
  }

  const ConditionalFields = () => {
    const type = getValue('permissons_type')

    if (type === 'permission_personal_codes') {
      return (
        <>
          <Rows>
            {renderRows()}
          </Rows>
          { numberOfRows < 5 ? (
            <StyledButton
              type="button"
              onClick={addRow}
              label="Lägg till person"
            />
          ) : null}
          <HR />
        </>
      )
    }

    if (type === 'permission_mutual') {
      return (
        <FieldRow>
          <Dropdown
            name="permission_mutual_level"
            options={PERMISSIONS_CONTACT_LEVELS}
            onChange={setValue('permission_mutual_level')}
            active={getValue('permission_mutual_level')}
            placeholder="Behörighetsnivå"
            half
            required
          />
          <Field
            name="permission_mutual_code"
            placeholder="Behörighetskod"
            onChange={setField('permission_mutual_code')}
            value={getValue('permission_mutual_code')}
            required
            half
            instructions="Endast siffror, mellan 6-12 st"
            pattern="[0-9]{6,12}"
          />
        </FieldRow>
      )
    }
    return null
  }

  return (
    <>
      <FieldGroup>
        <FieldGroup>
          <Dropdown
            name="permissons_type"
            options={PERMISSION_CODES_FORM}
            onChange={setValue('permissons_type')}
            active={getValue('permissons_type')}
            placeholder="Välj ett alternativ"
            required
          />
        </FieldGroup>
        {ConditionalFields()}

      </FieldGroup>
    </>
  )
}

export default PrivatePermissionCodes